import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-900 cursor-pointer">
              おかやま警備株式会社
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8">
            <Link 
              to="/" 
              className={`text-gray-700 hover:text-blue-900 font-medium whitespace-nowrap cursor-pointer ${isActive('/') ? 'text-blue-900 border-b-2 border-blue-900' : ''}`}
            >
              ホーム
            </Link>
            <Link 
              to="/services" 
              className={`text-gray-700 hover:text-blue-900 font-medium whitespace-nowrap cursor-pointer ${isActive('/services') ? 'text-blue-900 border-b-2 border-blue-900' : ''}`}
            >
              事業内容
            </Link>
            <Link 
              to="/company" 
              className={`text-gray-700 hover:text-blue-900 font-medium whitespace-nowrap cursor-pointer ${isActive('/company') ? 'text-blue-900 border-b-2 border-blue-900' : ''}`}
            >
              会社概要
            </Link>
            <Link 
              to="/recruit" 
              className={`text-gray-700 hover:text-blue-900 font-medium whitespace-nowrap cursor-pointer ${isActive('/recruit') ? 'text-blue-900 border-b-2 border-blue-900' : ''}`}
            >
              求人情報
            </Link>
            <Link 
              to="/blog" 
              className={`text-gray-700 hover:text-blue-900 font-medium whitespace-nowrap cursor-pointer ${isActive('/blog') ? 'text-blue-900 border-b-2 border-blue-900' : ''}`}
            >
              ブログ・新着情報
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-blue-900 cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-3">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className={`px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-900 font-medium cursor-pointer rounded ${isActive('/') ? 'bg-blue-50 text-blue-900' : ''}`}
              >
                ホーム
              </Link>
              <Link 
                to="/services" 
                onClick={() => setIsMenuOpen(false)}
                className={`px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-900 font-medium cursor-pointer rounded ${isActive('/services') ? 'bg-blue-50 text-blue-900' : ''}`}
              >
                事業内容
              </Link>
              <Link 
                to="/company" 
                onClick={() => setIsMenuOpen(false)}
                className={`px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-900 font-medium cursor-pointer rounded ${isActive('/company') ? 'bg-blue-50 text-blue-900' : ''}`}
              >
                会社概要
              </Link>
              <Link 
                to="/recruit" 
                onClick={() => setIsMenuOpen(false)}
                className={`px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-900 font-medium cursor-pointer rounded ${isActive('/recruit') ? 'bg-blue-50 text-blue-900' : ''}`}
              >
                求人情報
              </Link>
              <Link 
                to="/blog" 
                onClick={() => setIsMenuOpen(false)}
                className={`px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-900 font-medium cursor-pointer rounded ${isActive('/blog') ? 'bg-blue-50 text-blue-900' : ''}`}
              >
                ブログ・新着情報
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
